import {
  Component,
  ChangeDetectionStrategy,
  output,
  input,
  computed
} from '@angular/core';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ZefFormBase, ZefFormsModule } from '@zerops/zef/forms';
import { L7ConfigFormState } from '../l7-config-dialog.form';
import { FormSectionModule } from '@zerops/zui/form-section';
import { ZuiSeparatorComponent } from '@zerops/zui/separator';
import { CommonModule } from '@angular/common';
import { L7Config } from '@zerops/models/project';

@Component({
  selector: 'z-l7-config-form',
  templateUrl: './l7-config-form.component.html',
  styleUrl: './l7-config-form.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    ZefFormsModule,
    FormSectionModule,
    ZuiSeparatorComponent
  ]
})
export class L7ConfigFormComponent extends ZefFormBase<L7ConfigFormState> {
  configData = input<L7Config[]>();
  resetToDefaults = output();
  defaultValuesMap = computed(() => {
    const values = this.configData() ?? [];
    return values.reduce((map, item) => {
      map[item.name] = item.default || '';
      return map;
    }, {} as Record<string, string>);
  });
}
